import * as React from 'react'

import { useToggle } from '@factorialco/deprecated-design-system'
import classNames from 'classnames/bind'
import flatten from 'lodash/flatten'
import moment from 'moment'

import Popover from 'modules/core/components/Popover'

import type CalendarEvent from 'modules/calendar/store/models/CalendarEvent'

import DayEventsDetail from './DayEventsDetail'
import styles from './styles/index.module.css'

const cx = classNames.bind(styles)
interface Props {
  isFirst: boolean
  isLast: boolean
  day: moment.Moment
  holidays: CalendarEvent[]
  events: CalendarEvent[]
  leaves: CalendarEvent[]
  canEditBankHolidays: boolean
}

const DateCellWrapper = ({
  day,
  events,
  holidays,
  leaves,
  children,
  isFirst,
  isLast,
  canEditBankHolidays
}: React.PropsWithChildren<Props>) => {
  const [open, toggle] = useToggle()
  const clickable = events.length > 0 || holidays.length > 0 || leaves.length > 0
  const allEvents = flatten([events, holidays, leaves])
  const popoverDirection = isFirst ? 'top left' : isLast ? 'top right' : 'top center'

  return (
    <div
      className={cx('dateCellWrapper', {
        today: day.isSame(moment(), 'day'),
        sunday: day.day() === 0,
        saturday: day.day() === 6,
        clickable
      })}
    >
      {!clickable ? (
        children
      ) : (
        <Popover
          attachment={popoverDirection}
          targetAttachment="bottom center"
          size="huge"
          toggle={toggle}
          open={open}
        >
          <div className={styles.popoverTarget}>{children}</div>
          <div className={styles.popover}>
            <div className={styles.popoverHeader}>
              <div className={styles.popoverHeaderTitle}>{day.format('dddd D')}</div>
            </div>
            <div className={styles.popoverContent}>
              <DayEventsDetail
                calendarEvents={allEvents}
                canEditBankHolidays={canEditBankHolidays}
              />
            </div>
          </div>
        </Popover>
      )}
    </div>
  )
}

export default DateCellWrapper
